import MovieIcon from "../assets/icons/movieIcon.svg?react";
import SerialIcon from "../assets/icons/serialIcon.svg?react";
import GameIcon from "../assets/icons/gameIcon.svg?react";
import BookIcon from "../assets/icons/bookIcon.svg?react";
import ComicsIcon from "../assets/icons/comicsIcon.svg?react";
import CollectionIcon from "../assets/icons/collectionIcon.svg?react";
import FavoritesIcon from "../assets/icons/favoritesIcon.svg?react";
import HistoryIcon from "../assets/icons/historyIcon.svg?react";
import ReviewIcon from "../assets/icons/reviewIcon3.svg?react";
import AboutIcon from "../assets/icons/aboutIcon.svg?react";
import SettingsIcon from "../assets/icons/settingsIcon.svg?react";
import { LocalizationKeys } from "../i18n";

export const USERNAME_PLACEHOLDER = "{username}";

export interface INavItem {
  labelKey: string;
  link: string;
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
}

/**
 * Заменяет плейсхолдер username в навигационных элементах
 */
export const replaceUsernamePlaceholder = (
  items: INavItem[],
  username: string,
): INavItem[] => {
  return items.map((item) => ({
    ...item,
    link: item.link.replace(USERNAME_PLACEHOLDER, username),
  }));
};

export const contentNavItems: INavItem[] = [
  { labelKey: LocalizationKeys.NAV_MOVIES, link: "/movies", Icon: MovieIcon },
  {
    labelKey: LocalizationKeys.NAV_TV_SHOWS,
    link: "/tv-shows",
    Icon: SerialIcon,
  },
  { labelKey: LocalizationKeys.NAV_GAMES, link: "/games", Icon: GameIcon },
  { labelKey: LocalizationKeys.NAV_BOOKS, link: "/books", Icon: BookIcon },
  { labelKey: LocalizationKeys.NAV_COMICS, link: "/comics", Icon: ComicsIcon },
];

export const userNavItems: INavItem[] = [
  {
    labelKey: LocalizationKeys.NAV_COLLECTIONS,
    link: `/users/${USERNAME_PLACEHOLDER}/collections`,
    Icon: CollectionIcon,
  },
  {
    labelKey: LocalizationKeys.NAV_REVIEWS,
    link: `/users/${USERNAME_PLACEHOLDER}/reviews`,
    Icon: ReviewIcon,
  },
  {
    labelKey: LocalizationKeys.NAV_FAVORITES,
    link: `/users/${USERNAME_PLACEHOLDER}/favorites`,
    Icon: FavoritesIcon,
  },
  {
    labelKey: LocalizationKeys.NAV_HISTORY,
    link: `/users/${USERNAME_PLACEHOLDER}/history`,
    Icon: HistoryIcon,
  },
];

export const appNavItems: INavItem[] = [
  {
    labelKey: LocalizationKeys.NAV_SETTINGS,
    link: "/settings",
    Icon: SettingsIcon,
  },
  { labelKey: LocalizationKeys.NAV_ABOUT, link: "/about", Icon: AboutIcon },
];

export const allNavItems: INavItem[] = [
  ...contentNavItems,
  ...userNavItems,
  ...appNavItems,
];
